const ChatMoreLoading = {
  install: (Vue) => {
    Vue.component('ChatMoreLoading', () => {
      return import('./components/MoreLoading.vue')
    })
  }
}

export default ChatMoreLoading
